export default __webpack_public_path__ + "static/media/profile.0a3dd7b3.png";